<template>
  <b-table show-empty striped hover class="aco-table"
           :sort-by.sync="paging.sortBy" :sort-desc.sync="paging.sortDesc" sort-icon-left no-local-sorting @sort-changed="changeSortBy"
           :items="licenses" :fields="licenseFields">
    <template slot="empty">
      <div class="text-center">{{ $t('noResults') }}</div>
    </template>

    <template v-slot:cell(productName)="row">
      <div v-if="row.item.productName">{{ row.item.productName }}</div>
      <div v-else><i>{{ row.item.ean }}</i></div>
    </template>

    <template v-slot:cell(organizationName)="row">
      <div v-if="isOpenLicense(row.item.ownership)"><i> {{ $t('openLicense') }} </i></div>
      <div v-if="row.item.organizationName != null">{{ row.item.organizationName }}</div>
      <div v-if="isOrganizationNotFound(row.item)"><i>{{ row.item.ownerOrganizationNumber }}</i></div>
      <div v-if="isPrivateOwnerNotFound(row.item)"><i>{{ $t('notFound') }}</i></div>
    </template>

    <template v-slot:cell(show_details)="row">
      <router-link :to="{ name: 'LicenseDetails', params: { id: row.item.licenseId }}">
        <b-button size="sm" class="py-0">{{ $t('details') }}</b-button>
      </router-link>
    </template>
  </b-table>
</template>

<script>
  import BaseComponent from '../../components/BaseComponent'
  import { mapGetters } from 'vuex'

  export default {
    name: 'LicenseList',
    extends: BaseComponent,

    data: () => ({
      now: new Date(Date.now())
    }),

    created: function () {
      this.$store.dispatch('sessionStorage/checkSessionStorage')
      this.$store.dispatch('sessionStorage/updateState')
      this.$store.dispatch('licenses/getLicenses')
    },

    computed: {
      ...mapGetters('licenses', ['paging', 'licenses']),
      licenseFields () {
        return [
          { key: 'organizationName', label: this.$t('owner') },
          { key: 'licenseModel', label: this.$t('model'), tdClass: 'text-nowrap', formatter: value => this.translateAlternatives('licenseModels', value) },
          { key: 'channel', label: this.$t('channel'), sortable: false },
          { key: 'productName', label: this.$t('name'), sortable: true },
          { key: 'description', label: this.$t('description'), sortable: true },
          { key: 'status', label: this.$t('status'), sortable: true, tdClass: 'text-nowrap', formatter: (value, key, item) => this.translateLicenseStatus(value, key, item)},
          { key: 'orderId', label: this.$t('orderId'), sortable: true, tdClass: 'text-nowrap' },
          { key: 'validFrom', label: this.$t('validFrom'), sortable: true, thClass: 'text-nowrap', tdClass: 'text-nowrap', formatter: 'formatDate' },
          { key: 'validTo', label: this.$t('validTo'), sortable: true, thClass: 'text-nowrap', tdClass: 'text-nowrap', formatter: 'formatDate' },
          { key: 'usageRights', label: this.$t('usageRights'), formatter: (value, key, item) => this.formatUsageRights(value, key, item) },
          { key: 'isBundle', label: this.$t('bundle'), formatter: 'translateBooleans' },
          { key: 'show_details', label: '' }
        ]
      }
    },
    methods: {
      changeSortBy (sort) {
        if (sort.sortBy) {
          this.$store.dispatch('licenses/updatePaging', {
            sortBy: sort.sortBy,
            sortDesc: sort.sortDesc
          })
        }
      },
      isOpenLicense (ownership) {
        return (ownership === 'ALL')
      },
      isPrivateOwnerNotFound (item) {
        return (item.ownership === 'PRIVATE' && item.organizationName == null)
      },
      isOrganizationNotFound (item) {
        return (item.ownership === 'ORGANIZATION' && item.organizationName == null && item.ownerOrganizationNumber != null)
      },
      formatUsageRights (value, key, item) {
        if (item.licenseModel !== 'INDIVIDUAL' && item.licenseModel !== 'ORGANIZATIONAL') {
          return '-'
        }

        return value
      },
      translateLicenseStatus(value, key, item) {
        if (value === 'CANCELLED') {
          return this.$t('constants.CANCELLED')
        }

        if (value !== 'ACTIVE') {
          return this.$t(value);
        }

        if (!item.validFrom || !item.validTo) {
          return this.$t('constants.ACTIVE')
        }

        const from = new Date(item.validFrom)
        const to = new Date(item.validTo);

        return this.now >= from && this.now <= to
          ? this.$t('constants.ACTIVE')
          : this.$t('constants.INACTIVE')
      }
    },
    i18n: {
      messages: {
        en: {
          'model': 'Model'
        },
        nb: {
          'model': 'Modell'
        }
      }
    }
  }

</script>
